import { render, staticRenderFns } from "./ProductWindowActivity.vue?vue&type=template&id=69234370&scoped=true"
import script from "./ProductWindowActivity.vue?vue&type=script&lang=js"
export * from "./ProductWindowActivity.vue?vue&type=script&lang=js"
import style0 from "./ProductWindowActivity.vue?vue&type=style&index=0&id=69234370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69234370",
  null
  
)

export default component.exports